<template>
  <div v-if="(user.role == 2 && appointmentStore.next_appointment && appointmentStore.next_appointment.id != user.professional.now_appointment?.id && this.timeToNextAppointment)" class="mr-8 text-red-600">
    <div class="hidden lg:block font-semibold p-2 rounded-md border bg-white border-red-600">
        Próxima consulta em <div class="inline-block w-[39px]">{{ this.timeToNextAppointment }}</div>
    </div>
    <div class="block lg:hidden" :title="'Próxima consulta em ' + this.timeToNextAppointment">
        <font-awesome-icon icon="fa-regular fa-clock" class="text-2xl" />
    </div>
  </div>
  <div v-else-if="(user.role == 2 && user.professional.now_appointment && user.professional.now_appointment.id != appointmentStore.appointment?.id)" class="mr-8 text-red-600">
    <div class="cursor-pointer font-semibold p-2 rounded-md border bg-white border-red-600" @click="openAppointment">
      <span class="hidden lg:inline-block mr-1">Acessar</span>Consulta
    </div>
  </div>
</template>
<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import { useAppointmentStore } from '@/Store/Appointment'
import { useNotificationStore } from '@/Store/Notification'

export default {
  data() {
    return {
      appointmentStore: useAppointmentStore(),
      notificationStore: useNotificationStore(),
      timeToNextAppointment: '',
      timeToNextAppointmentInterval: null
    }
  },
  components: {
    
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  mounted() {

  },
  methods: {
    openAppointment() {
      this.$inertia.visit(`/patients/detail/${this.user.professional.now_appointment.patient_id}/${this.user.professional.now_appointment.id}`);
    },
    millisToMinutesAndSeconds(millis) {
      var minutes = Math.floor(millis / 60000);
      var seconds = ((millis % 60000) / 1000).toFixed(0);
      if(seconds == 60) {
        seconds = 0;
        if(minutes > 0) {
          minutes++;
        }
      }
      return minutes.toString().padStart(2, '0') + ":" +  seconds.toString().padStart(2, '0');
    },
    timeToNextAppointmentIncrementTime() {
      if(this.user.role == 2 && this.appointmentStore.next_appointment  && (!this.appointmentStore?.appointment || this.appointmentStore.appointment.id != this.appointmentStore.next_appointment.id)) {
        let date1 = new Date();
        let date2 = new Date(this.appointmentStore.next_appointment.date_start);
        if(date2.getTime() > date1.getTime()) {
            let diffTime = Math.abs(date2 - date1);
            this.timeToNextAppointment = this.millisToMinutesAndSeconds(diffTime);
            if(this.timeToNextAppointment == '00:00') {
                clearInterval(this.timeToNextAppointmentInterval);
                this.timeToNextAppointment = '';
                this.notificationStore.start();
            }
        } else {
            if(this.timeToNextAppointmentInterval) {
                clearInterval(this.timeToNextAppointmentInterval);
            }
            this.timeToNextAppointment = '';
            this.notificationStore.start();
        }
      } else {
        this.timeToNextAppointment = '';
        if(this.timeToNextAppointmentInterval) {
          clearInterval(this.timeToNextAppointmentInterval);
        }
      }
    }
  },
  mounted() {
    if(this.user.role == 2) {
      this.appointmentStore.$subscribe((mutation, state) => {
        if(state.next_appointment) {
          this.timeToNextAppointmentInterval = setInterval(this.timeToNextAppointmentIncrementTime, 1000);
        } else if(this.timeToNextAppointmentInterval) {
          clearInterval(this.timeToNextAppointmentInterval);
        }
      })
    }
  },
  unmounted() {
    clearInterval(this.timeToNextAppointmentInterval);
  },
}
</script>